import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ size = "md", testId = "logo-home" }) => {
  const sz = size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-2xl";
  const dz = size === "lg" ? "w-4 h-4" : size === "sm" ? "w-2.5 h-2.5" : "w-3 h-3";
  return (
    <Link to="/" data-testid={testId} className="inline-flex items-center gap-2 group">
      <span className={`logo-diamond ${dz}`} aria-hidden />
      <span className={`logo-text ${sz}`}>
        Content<span className="blue">Snap</span>
      </span>
    </Link>
  );
};

export default Logo;
